export default __webpack_public_path__ + "media/images/friends-cropped-f568f8e08063fc1008c33efc336d7816.png";